import { useRef, useState } from 'react';
import './ToolSwapAction.css';

export type SwapTool = 'black' | 'white' | 'pair' | 'black-stone' | 'white-stone' | 'peg' | 'peg-black' | 'store';
/** A sample tool and its adjacent action form one native, backgroundless button. */
export function ToolSwapAction({ tool, label, testId, onClick, disabled = false, bowlAsset = false }: {
  tool: SwapTool; label: string; testId: string; onClick: () => unknown; disabled?: boolean; bowlAsset?: boolean;
}) {
  const [sending, setSending] = useState(false);
  const inFlight = useRef(false);
  return <button type="button" className="tool-swap-action" data-testid={testId}
    disabled={disabled || sending} aria-busy={sending || undefined}
    onClick={() => {
      if (disabled || inFlight.current) return;
      const result = onClick();
      if (result && typeof (result as PromiseLike<unknown>).then === 'function') {
        inFlight.current = true;
        setSending(true);
        Promise.resolve(result).finally(() => { inFlight.current = false; setSending(false); }).catch(() => {});
      }
    }}>
    {bowlAsset && (tool === 'black' || tool === 'white')
      ? <img className="tool-swap-approved-bowl" src={`/generated/vessels/goke-rim-${tool}.png`} alt="" aria-hidden="true" draggable={false} />
      : <SwapToolSample tool={tool} whiteFirst={bowlAsset} />}
    <span className="tool-swap-text">{label}</span>
  </button>;
}

export function SwapToolSample({ tool, whiteFirst = false }: { tool: SwapTool; whiteFirst?: boolean }) {
  return <svg className="tool-swap-sample" viewBox="0 0 52 40" aria-hidden="true">
      {tool === 'store' ? <>
        <ellipse cx="26" cy="22" rx="20" ry="13" fill="#765030" />
        <ellipse cx="26" cy="20" rx="17" ry="10" fill="#50351f" stroke="#ac8050" />
      </> : (tool === 'peg' || tool === 'peg-black') ? <>
        <image href="/generated/vessels/reversi-wood-tray.png" x="0" y="0" width="52" height="40" />
        {[16,25,34].map(x=><g key={x}><path d={`M${x-2} 25V16Q${x} 13 ${x+2} 16V25Z`} fill={tool === 'peg-black' ? '#292725' : '#eee9dc'} stroke={tool === 'peg-black' ? '#171615' : '#aaa596'} strokeWidth=".5" /><ellipse cx={x} cy="16" rx="2" ry="1" fill={tool === 'peg-black' ? '#45423e' : '#fffdf3'} /></g>)}
        <path d="M14 30L32 30M19 33L37 33" stroke={tool === 'peg-black' ? '#292725' : '#eee9dc'} strokeWidth="2" strokeLinecap="round" />
      </> : <>
        {(tool === 'black' || tool === 'white') && <><path d="M5 21Q8 37 26 37Q44 37 47 21Z" fill="#987044" />
          <ellipse cx="26" cy="21" rx="21" ry="9" fill="#61432c" stroke="#b48d5a" /></>}
        {(tool === 'black' || tool === 'black-stone' || tool === 'pair') && <ellipse cx={tool === 'pair' ? (whiteFirst ? 36 : 16) : 24} cy="17" rx="10" ry="7" fill="#292725" stroke="#171615" />}
        {(tool === 'white' || tool === 'white-stone' || tool === 'pair') && <ellipse cx={tool === 'pair' ? (whiteFirst ? 16 : 36) : 26} cy="17" rx="10" ry="7" fill="#eeeade" stroke="#b3aea3" />}
      </>}
    </svg>;
}

export function QuietSwapTool({ tool, bowlAsset = false }: { tool: SwapTool; bowlAsset?: boolean }) {
  return <div className="tool-swap-row tool-swap-quiet" aria-hidden="true">{bowlAsset && (tool === 'black' || tool === 'white') ? <img className="tool-swap-approved-bowl" src={`/generated/vessels/goke-rim-${tool}.png`} alt="" draggable={false} /> : <SwapToolSample tool={tool} />}</div>;
}
